module.exports = __webpack_public_path__ + "static/media/biodiesel.47b706d0.svg";